import React, { useState, useEffect, useRef } from 'react';
import cn from 'classnames';
import Transition from 'react-transition-group/Transition';
import { CloseIcon } from "../Icon";
import Portal from '../../helpers/Portal';
import StatusMessage from '../StatusMessage';
import styles from './Notification.module.scss';
const getStatusMessageType = (type) => {
    if (type === 'error') {
        return 'invalid';
    }
    if (type === 'success') {
        return 'valid';
    }
    return type;
};
const getIconName = (type) => {
    switch (type) {
        case 'success':
            return 'checkbox';
        case 'info':
            return 'info';
        case 'warning':
            return 'warning';
        case 'error':
            return 'error';
        default:
            return undefined;
    }
};
const getRole = (type) => {
    switch (type) {
        case 'success':
        case 'info':
            return 'status';
        case 'warning':
        case 'error':
            return 'alert';
        default:
            return undefined;
    }
};
const Notification = ({ timespan = 7000, topOffset = 0, shouldIgnoreTimeSpan = false, position = 'center', shouldHaveIcon = true, className, type, onExit, children, additionalClass, additionalStatusMessageClass, isPortalEnabled = true, contentContainerWidth = 'large', labels = {}, isNotificationSticky = true, isFullwidth = true, }) => {
    const [isShown, setIsShown] = useState(true);
    const timerRef = useRef(null);
    const resetTimer = () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
    };
    useEffect(() => {
        if (!shouldIgnoreTimeSpan) {
            timerRef.current = window.setTimeout(() => {
                setIsShown(false);
            }, timespan);
        }
        return resetTimer;
    }, [timespan]);
    const [isSticky, setIsSticky] = useState(false);
    const handleScroll = () => {
        const isOutsideOfViewport = window.pageYOffset >= topOffset;
        setIsSticky(isOutsideOfViewport);
    };
    useEffect(() => {
        if (isNotificationSticky) {
            handleScroll();
            window.addEventListener('scroll', handleScroll);
            return () => {
                window.removeEventListener('scroll', handleScroll);
            };
        }
        return () => { };
    }, []);
    const handleExit = () => {
        if (onExit) {
            onExit();
        }
    };
    const handleCloseClick = () => {
        setIsShown(false);
        resetTimer();
    };
    const NotificationBar = (transitionState) => {
        return (React.createElement("div", { className: cn(isFullwidth ? styles.fullWidthContainer : styles.embeddedContainer, contentContainerWidth === 'small' && styles.smallContentContainer, styles[type], styles[transitionState], isSticky && styles.stickyWrapper, !isPortalEnabled && styles.appWrapper, additionalClass), style: isPortalEnabled ? { top: isSticky ? 0 : topOffset } : {}, role: getRole(type), "aria-live": "polite" },
            React.createElement("div", { className: cn(styles.content, styles[contentContainerWidth], styles[position], className) },
                React.createElement(StatusMessage, { icon: shouldHaveIcon ? getIconName(type) : undefined, type: getStatusMessageType(type), message: children, className: cn(styles.statusMessage, additionalStatusMessageClass) }),
                React.createElement("button", { type: "button", className: styles.closeButton, onClick: handleCloseClick, "aria-label": labels.close },
                    React.createElement(CloseIcon, { className: styles.closeButtonIcon, size: "small" })))));
    };
    const WrapContent = (transitionState) => {
        return React.createElement(Portal, null,
            " ",
            NotificationBar(transitionState),
            " ");
    };
    return (React.createElement(Transition, { in: isShown, timeout: 300, appear: true, unmountOnExit: true, onExited: handleExit }, (transitionState) => isPortalEnabled ? WrapContent(transitionState) : NotificationBar(transitionState)));
};
export default Notification;
//# sourceMappingURL=Notification.js.map